import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

type CodeEditorModalProps = {
  isOpen?: boolean;
  open?: boolean;
  onClose: () => void;
  onSave?: (code: string) => void;
  onChange?: (next: string) => void;
  value?: string;
  initialCode?: string;
  language?: string;
  title?: string;
};

const CodeEditorModal: React.FC<CodeEditorModalProps> = ({
  isOpen,
  open,
  onClose,
  onSave,
  onChange,
  value,
  initialCode,
  language = 'javascript',
  title = 'Editor de Código',
}) => {
  const openState = Boolean(isOpen ?? open);
  const seedValue = value ?? initialCode ?? '';
  const [internal, setInternal] = useState(seedValue);

  useEffect(() => {
    if (openState) setInternal(seedValue);
  }, [openState, seedValue]);

  if (!openState) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="flex h-[80vh] w-full max-w-4xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl dark:bg-gray-900">
        <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3 dark:border-gray-800">
          <div className="text-sm font-semibold text-slate-700 dark:text-slate-200">
            {title}{' '}
            <span className="ml-1 rounded bg-slate-100 px-1.5 py-0.5 text-xs text-slate-500 dark:bg-gray-800 dark:text-slate-400">
              {language}
            </span>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-slate-500 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-gray-800"
            title="Fechar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <textarea
          spellCheck={false}
          className="flex-1 w-full resize-none bg-slate-50 p-4 font-mono text-sm text-slate-800 outline-none dark:bg-gray-950 dark:text-slate-100"
          value={internal}
          onChange={(e) => setInternal(e.target.value)}
          aria-label={`${title} code editor`}
        />
        <div className="flex justify-end gap-2 border-t border-slate-200 px-4 py-3 dark:border-gray-800">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50 dark:border-gray-700 dark:bg-gray-900 dark:text-slate-200 dark:hover:bg-gray-800"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={() => {
              onChange?.(internal);
              onSave?.(internal);
              onClose();
            }}
            className="rounded-md bg-brand-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-700"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CodeEditorModal;
